import { createFileRoute } from "@tanstack/react-router";
import BlogIOPWithHousingOptionsNJ from "@/pages/BlogIOPWithHousingOptionsNJ";
import { routeHead } from "@/lib/route-head";

export const Route = createFileRoute("/iop-with-housing-options-nj")({
  head: () => routeHead("/iop-with-housing-options-nj"),
  component: BlogIOPWithHousingOptionsNJ,
});
